module.exports = __webpack_public_path__ + "static/media/products_bg@3x.a98a90fc.webp";